import React from 'react';
import { Line } from 'react-chartjs-2';

import createLogger from 'logging';

const logger = createLogger('GCF_Line');

const GCF_Area1 = require('../../Resources/Data/GCF_Area_1.json')
const GCF_Area2 = require('../../Resources/Data/GCF_Area_2.json')
const GCF_Area3 = require('../../Resources/Data/GCF_Area_3.json')
const GCF_Area4 = null

const GCF = { Area1: GCF_Area1, Area2: GCF_Area2, Area3: GCF_Area3, Area4: GCF_Area4 }

const nat = ["France", "Belgium", "United Kingdom", "United States", "Italy", "Spain", "Germany", "Switzerland"]
var colors = [
    { r: 255, g: 0, b: 0 },
    { r: 0, g: 255, b: 0 },
    { r: 0, g: 0, b: 255 },

    { r: 64, g: 64, b: 200 },
    { r: 200, g: 64, b: 64 },
    { r: 64, g: 200, b: 64 },

    { r: 64, g: 255, b: 255 },
    { r: 255, g: 255, b: 64 },
    { r: 255, g: 255, b: 64 },
]

function getRGBA(color, alpha) {
    return `rgba(${color.r},${color.g},${color.b},${alpha})`
}

function GenerateData(ar, ag) {
    var datas = {}
    datas.labels = [2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020]
    datas.datasets = []
    for (let i = 0; i < nat.length; i++) {
        datas.datasets.push({
            label: nat[i],
            backgroundColor: getRGBA(colors[i], 0),
            borderColor: getRGBA(colors[i], 0.5),
            pointBackgroundColor: getRGBA(colors[i], 1),
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            lineTension: 0.1,
            pointHoverBorderColor: getRGBA(colors[i], 1),
            data: []
        })
    }
    var file
    var result
    if (ar === 'Area1') { file = GCF.Area1.Area_1.find((element => { return (element.name === global.name_area) })); }
    if (ar === 'Area2') { file = GCF.Area2.Area_2.find((element => { return (element.name === global.name_area) })); }
    if (ar === 'Area3') { file = GCF.Area3.Area_3.find((element => { return (element.name === global.name_area) })); }
    if (ar === 'Area4') { file = GCF.Area4.Area_4.find((element => { return (element.name === global.name_area) })); }
    if (file) {
        if (ag === 'Area2') {
            result = file.Aggregation.area_2
        }
        if (ag === 'Area3') {
            result = file.Aggregation.area_3
        }
        if (ag === 'Area4') {
            result = file.Aggregation.area_4
        }
        if (ag === 'Area5') {
            result = file.Aggregation.area_5
        }
    }
    if (result)
        result.forEach((element) => {
            var i1 = nat.indexOf(element.nat)
            var i2 = datas.labels.indexOf(element.year)
            if (i1 !== -1 && i2 !== -1)
                datas.datasets[i1].data[i2] = element.GCF
        })

    return datas
}




export default class GCF_Line extends React.Component {
    constructor(props) {
        super(props)
        logger.info('Construction: '+props);
        this.state = {}
        this.state.ar = this.props.ar;
        this.state.ag = this.props.ag;
        this.state.data = GenerateData(this.state.ar, this.state.ag);
    }

//    handleChange = event => {
    static getDerivedStateFromProps(props, state) {
//      componentWillReceiveProps() {
        this.setState(state => {
            state.ag = global.ag
            state.ar = global.ar
        })
    }

    getLabel() {
        if (this.state.ag === 'Area2') return 'Departments'
        if (this.state.ag === 'Area3') return 'Districts'
        if (this.state.ag === 'Area4') return 'Cities'
    }

    render() {
        return (
            <div>
                <h2>GCF Chart of {this.getLabel()}</h2>
                <Line data={GenerateData(this.state.ar, this.state.ag)} />
            </div>
        );
    }
}
